/**********************************************************************
// @@@ START COPYRIGHT @@@
// AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
// Copyright 2018 - 2019
// Avi Solar Energy Pvt Ltd.
// Protected as an unpublished work.
// The computer program listings, specifications and documentation
// herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
// and shall not be reproduced, copied, disclosed, or used in whole or in part for
// any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <div>
    <v-data-table
      :headers="computedHeader"
      :items="tableData"
      hide-actions
      :pagination.sync="pagination"
      :custom-sort="(items, index, isDesc) => customSortHandler(items, index, isDesc)"
      :loading="loading"
      class="elevation-1 primary header"
    >
      <template v-slot:items="props">
        <td
          v-for="(item, key) in props.item"
          :key="`${key}-${item}`"
          class="text-xs-center dataWidth primary"
          :class="key == 'sensor_time' ? '' : 'number--text'"
        >
          {{ item }}
        </td>
      </template>
      <template v-slot:no-data>
        <tr>
          <td class="text-sm-center">
            {{ $t("No Data Available") }}
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import moment from 'moment'
import WSApi from "@/services/WeatherStation.js";

export default {
  props: ["date", "wsId", "plantId"],
  data: () => ({
    tableData: [],
    headers: [],
    pagination: {
      sortBy: "sensor_time",
      rowsPerPage: -1,
      descending: true,
    },
  }),
  computed: {
    isNowCallingApi() {
      return `${this.date.from} ${this.date.to} ${this.plantId} ${this.wsId}`;
    },
    computedHeader() {
      const cloneHeader = _.cloneDeep(this.headers);
      return cloneHeader.map((el) => {
        return {
          text: el.unit ? `${this.$t(el.name)} ${el.unit}` : this.$t(el.name),
          value: el.value,
          align: "center",
        };
      });
    },
  },
  created() {
    this.getWsTableData();
  },
  methods: {
    customSortHandler(items, index, isDesc) {
      // Custom sorting logic here
      console.log(index, 'INDEX INNNNI***()***', items, isDesc)
      this.pagination.sortBy = index
      return items.sort((a, b) => {
        if (index == 'sensor_time') {
          return isDesc ? moment(a['sensor_time']).diff(moment(b['sensor_time'])) : moment(b['sensor_time']).diff(moment(a['sensor_time']))
        } else {
          const fieldA = a[index] == 'N/A' || a[index] == null ? Number.MIN_SAFE_INTEGER : parseFloat(a[index]);
          const fieldB = b[index] == 'N/A' || b[index] == null ? Number.MIN_SAFE_INTEGER : parseFloat(b[index]);

          return isDesc ? fieldB - fieldA : fieldA - fieldB;
        }
      });
    },
    async getWsTableData() {
      this.loading = true;
      const param = {
        plantId: this.plantId,
        dateFrom: this.date.from,
        dateTo: this.date.to,
        wsId: this.wsId,
      };
      let response = "";
      if (
        this.plantId === "114" ||
        this.plantId === "151" ||
        this.plantId === "159"
      ) {
        response = await WSApi.wsDataTableAll(param);
      } else {
        response = await WSApi.wsDataTable(param);
      }
      if (response.status === 200) {
        this.tableData = response.data.message.data;
        this.headers = response.data.message.headers;
      }
    },
  },
  watch: {
    isNowCallingApi() {
      this.getWsTableData();
    },
  },
};
</script>

<style scoped>
.dataWidth {
  min-width: 100px;
}

.header {
  height: 500px;
  overflow: auto;
}

.header th {
  z-index: 1 !important;
  position: sticky !important;
  top: 0 !important;
  color: var(--v-extraGrey) !important;
  background: var(--v-primary-base) !important;
}
</style>

<style>
.header .v-table__overflow {
  overflow: unset;
}
</style>
